import { escrowPrintCheckUrl, escrowPrintCheckUrlAndSetDate } from 'utilities/accounting/escrowPrintCheckUrl';
import { downloadFile } from '../../../../ui-toolkit/utilities/downloadFile';

export const downloadEscrowCheck = () => (checkId: string) => {
  const url = escrowPrintCheckUrl(checkId);
  const method = 'GET';
  downloadFile(url, undefined, method);
};

export const downloadEscrowCheckAndSetDate = () => (checkId: string) => {
  const url = escrowPrintCheckUrlAndSetDate(checkId);
  downloadFile(url, undefined, 'POST');
};
